import { Outlet } from "react-router-dom";
import ArrivalsList from "./ArrivalsList";

// Прибывшие багажи — список отправок, чей багаж прибыл на станцию назначения.
// Сегмент "baggages" задаётся родителем в baggages-routes.ts.
export const adminBaggageArrivalsRoutes = [
  {
    path: "arrivals",
    element: Outlet,
    children: [
      {
        path: "",
        element: ArrivalsList,
      },
    ],
  },
];
